import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { GetPendingApplicationsRequest } from './DTOs/get-pending-applications-request';
import { Observable } from 'rxjs';
import { PendingApplicationDtRetInfo } from './DTOs/pending-applications-dt-ret-info';
import { DumbPendingApplication } from './DTOs/dumb-pending-application';
import { PendingApplicationDetails } from './DTOs/pending-application-details';
import { SavePendingAppRequest } from './DTOs/save-pending-app-request';
import { GeneralApplicationInfoHolder } from '../sign-up/DTOs/general-application-info-holder';
import { MembershipLevelOption } from './DTOs/membershipLevelOption';
import { VerifyRejectRequest } from '../core/verify-reject-request';

@Injectable({
    providedIn: 'root'
})
export class PendingApplicationsService {
    readonly relativeBase = "pending-applications/";

    constructor(private http: ApiClient) { }

    getAllPendingApplications(request: GetPendingApplicationsRequest): Observable<PendingApplicationDtRetInfo> {
        return this.http.post(this.relativeBase + "get-all", request);
    }
    getPendingApplicationInfo(Id: string): Observable<PendingApplicationDetails> {
        return this.http.get(this.relativeBase + Id);
    }
    UpdatePendingAppInfo(request: SavePendingAppRequest) {
        return this.http.post(this.relativeBase + "update", request);
    }
    getGeneralAppInfo(): Observable<GeneralApplicationInfoHolder> {
        return this.http.get(this.relativeBase + "general-form-info");
    }
    getMembershipLevelInfo(): Observable<MembershipLevelOption[]> {
        return this.http.get(this.relativeBase + "level-info");
    }
    rejectApplication(request: VerifyRejectRequest) {
        return this.http.post(this.relativeBase + "reject", request);
    }
    approveApplication(request: VerifyRejectRequest) {
        return this.http.post(this.relativeBase + "approve", request);
    }

}
